// Public contact destinations from the user-supplied CVs.
export const contactDetails = {
  email: "lilter96dotnet@gmail.com",
  github: "https://github.com/lilter96",
  linkedin: "https://www.linkedin.com/in/terentiy-gatsukov/",
  telegram: "https://t.me/lilter96",
  phone: "+375 33 385-44-32",
  phoneHref: "tel:+375333854432",
} as const;
